export const hotelAmenities = {
  pool: "Pool",
};
